import InfoIcon from '@images/icons/info-circle-black.svg?react'
import { v4 as uuid } from 'uuid'

import './warningMessage.scss'

interface WarningMessageProps {
  title: string
  lines: string | string[]
}

const WarningMessage = ({ title, lines }: WarningMessageProps) => {
  return (
    <div className='warning-message-wrapper warning-block'>
      <InfoIcon />
      <div className='right'>
        <div className='label'>{title}</div>

        {Array.isArray(lines) ? lines?.map((line: string) => <p key={uuid()}>{line}</p>) : <p>{lines}</p>}
      </div>
    </div>
  )
}

export default WarningMessage
